import React from "react";
import styles from "./LoginV2.module.scss";
import HeroSvg from "./hero_image.svg";

export const HeroImage = () => {
  return (
    <img src={HeroSvg} alt="Hero" style={{
      width: "100%",
      height: "100%",
      objectFit: "cover"
    }} />
  )
}